import { observable } from 'mobx';

export type TripReportResponseArgs = {
  id: number;
};

export type TripReportArgs = {
  id: number;
};

export const convertTripReportResponseToArgs = (response: TripReportResponseArgs) => {
  const args: TripReportArgs = {
    id: response.id
  };
  return args;
};

export default class TripReport {
  @observable id: number;

  constructor(args: TripReportArgs) {
    this.id = args.id;
  }
}
